<template>
  <div class="user-orders-wrap">
    <div v-for="(otherComponent, index) in otherComponents" :key="index">
       <div v-if="otherComponent.type === 'cd-webMyAccount'">
          <ul class="order-ls-title">
            <li style="width:257px;"><!-- 餐厅 -->{{$t('orders.restaurant')}}</li>
            <!-- 订单号 -->
            <!-- <li style="width:220px;">{{'订单号'}}</li> -->
            <li style="width:50px;"><!-- 总价 -->{{$t('orders.total')}}</li>
            <li style="width:145px;"><!-- 订单状态 -->{{$t('orders.status')}}</li>
            <li style="width:140px;"><!-- 下单时间 -->{{$t('orders.orderTime')}}</li>
            <li style="width:146px;"><!-- 下单时间 -->{{$t('orders.action')}}</li>
          </ul>
          <Spin v-if="isLoading" size="large" fix></Spin>
          <!-- <cd-loading :isLoading="isLoading">

          </cd-loading> -->
          <!-- 无订单提示 -->
          <div v-if="orders.length > 0" class="order-list-wrap">
            <div v-for="(item, index) in orders" :key="index" class="order-table-border">
              <table class="order__tb">
                <tbody>
                  <tr class="order-intro">
                    <td class="store-name" width="257">
                      <p>{{item.storeName}}</p>
                      <p>{{$t('orders.orderNo')}}：{{ item.orderNo }}</p>
                    </td>
                    <!-- <td class="order-no" width="220">{{item.orderNo}}</td> -->
                    <td class="order-total" width="50">{{'￥'+item.totalPrice}}</td>
                    <td width="145">{{$t(`orders.orderStausList[${item.status}]`)}}</td>
                    <td class="order-times" width="140">{{item.createTime}}</td>
                    <td class="order-times" width="146">
                      <Button class="cd-btn" size="large" @click.stop="changeItem(index)">
                        {{$t('orders.view')}}
                      </Button>
                    </td>
                  </tr>
                  <tr v-show="index===currentIndex" class="order-detail">
                    <td colspan="5">
                       <!-- <cd-loading :isLoading="isLoadingDetail" shape="bar"></cd-loading> -->
                      <div class="order-detail-box clearfix">
                        <Spin v-if="isLoadingDetail" fix size="large"></Spin>
                        <!-- 订单详情左侧 -->
                        <div class="order-detail__l">
                          <div class="order-detail-main" v-if="orderDetail.orderTypeName">
                            <!-- 自取时间 -->
                            <p v-if="orderDetail.sendType === 2">
                              <span>
                                {{$t('tip.mealTime')}}
                              </span>
                              {{': ' + orderDetail.sendTime.replace(/[0-9]+-/, '')}}
                              <em class="order-type">{{ orderDetail.orderTypeName }}</em>
                            </p>
                            <!-- 自取时间 -->
                            <p v-else-if="orderDetail.sendType === 4">
                              <span>
                                {{$t('orders.scheduled')}}
                              </span>
                              {{': ' + orderDetail.sendTime.replace(/[0-9]+-/, '')}}
                              <em class="order-type">{{ orderDetail.orderTypeName }}</em>
                            </p>
                            <!-- 预计送达时间 -->
                            <p v-else>
                              <span>
                                {{$t('tip.deliveryTime')}}
                              </span>
                              {{': ' + orderDetail.sendTime.replace(/[0-9]+-/, '')}}
                              <em class="order-type">{{ orderDetail.orderTypeName }}</em>
                            </p>
                            <!-- 订餐人 -->
                            <p>
                              <span>
                                {{$t('user.name')}}
                              </span>
                              {{': ' + orderDetail.name}}
                            </p>
                            <!-- 电话 -->
                            <p>
                              <span>{{$t('user.phone.mobile')}}</span>
                              {{': ' + orderDetail.phone}}
                            </p>
                            <!-- 地址 -->
                            <p>
                              <span>
                                {{$t('user.addr')}}
                              </span>
                              {{orderDetail.sendType===2?': ' + orderDetail.storeAddress:': ' + orderDetail.address}}
                            </p>
                            <p v-if="
                              orderDetail.sendType === 2 &&
                              orderDetail.takeMealSn &&
                              otherComponent.fields.showMealNumber &&
                              otherComponent.fields.showMealNumber.val"
                            >
                              <span>
                                {{'取餐号'}}
                              </span>
                              {{ '：' +  orderDetail.takeMealSn}}
                            </p>
                          </div>
                           <!-- <p v-if="orderDetail.orderRefund
                            && orderDetail.orderRefund.status
                            && orderDetail.orderRefund.status===3"
                            class="order-cancel-reason">{{'agreeForApply'}}</p>

                          <p v-if="orderDetail.orderStatus === -1
                            && !orderDetail.isAlreadyCancelOrder
                            && orderDetail.progress.length > 1
                            && orderDetail.cancelReason"
                            class="order-cancel-reason">{{'order_cancelReason'}} {{orderDetail.cancelReason}}</p> -->

                          <div v-if="orderDetail.progress && orderDetail.progress.length > 0" class="order-steps-box">
                            <div v-for="(step, i) in orderDetail.progress" :key="i" class="status-msg">
                              <span class="step-name">{{$t(`orders.orderStausList[${step.status}]`)}}</span>
                              <span class="step-time">{{step.createTime.replace(/[0-9]+-/, '')}}</span>
                              <p v-if="i==0&&step.status==1" class="progress-btn-box">
                                <!-- 取消订单 - start -->
                                <!-- 订单未确认时 -->
                                <Button
                                  v-if="orderDetail.orderStatus === 1 || orderDetail.orderStatus === 7"
                                  @click.native="cancelOrder(orderDetail.orderId)"
                                  class="cd-btn"><!-- 取消订单 -->{{$t('orders.cancel')}}</Button>
                                <!-- 取消订单 - end -->
                                <!-- 用户申请取消订单 - start -->
                                <!-- 订单已确认时且非发起取消申请状态 orderRefund.status!==1 -->
                                <Button v-if="isApplyCancelBtn
                                              && otherComponent.fields
                                              && otherComponent.fields.orderCancel
                                              && otherComponent.fields.orderCancel.val"
                                  @click.native="applyCancleorder"
                                  class="bg-main fc-main" sub>{{$t('orders.applyCancellation')}}</Button>
                                <!-- 用户申请取消订单 - end -->

                                <!-- 查看申请取消订单进度 - start -->
                                <!-- 订单已发起取消申请且未撤销且未审核 orderRefund.status===1 -->
                                <Button v-if="isCancelProgressBtn
                                              && otherComponent.fields
                                              && otherComponent.fields.orderCancel
                                              && otherComponent.fields.orderCancel.val"
                                  @click.native="showCancelProgress"
                                  class="bg-secondary fc-main">{{$t('orders.scheduleCancellation')}}</Button>
                                <!-- 查看申请取消订单进度 - end -->
                                &nbsp;
                                <Button class="cd-btn" @click.native="gotoPay(orderDetail)"><!-- 继续支付 -->{{$t('orders.continue')}}</Button>
                              </p>
                              <p v-if="i==0&&step.status==14" class="progress-btn-box">
                                <!-- <Button v-if="orderDetail.showRiderLocation" class="bg-main fc-main" @click.native="showRiderLocation(orderDetail)" sub>{{'查看骑手位置'}}</Button> -->
                                <Button class="cd-btn" @click.native="finishOrder(orderDetail.orderId)"><!-- 已取餐 -->{{$t('orders.itHasTakenMeals')}}</Button>
                              </p>
                            </div>
                            <!-- 进度条 -->
                            <div class="order-step-bar" :class="['step-' + orderDetail.progress.length, {'step-4-1':item.status==14}]"></div>
                          </div>
                        </div>
                        <!-- 订单详情右侧 -->
                        <div class="order-detail__r" ref="order-detail">
                          <div class="order-title-box">
                            <h4>{{$t('food.info')}}</h4>
                            <div class="order-control-btns">
                              <!-- 订单评价按钮 - start -->
                              <!-- <Button v-if="projectName === 'standard' && orderDetail.orderStatus===100 && !orderDetail.commentId && overTime(orderDetail.orderDate)"
                                @click.native="showComment">{{'订单评价'}}</Button> -->
                              <!-- 订单评价按钮 - end -->

                              <!-- 我的评价按钮 - start -->
                              <!-- <Button v-if="projectName === 'standard' && orderDetail.orderStatus===100 && orderDetail.commentId"
                                @click.native="showComment">{{'我的评价'}}</Button> -->
                              <!-- 我的评价按钮 - end -->

                              <!-- 商家回复按钮 - start -->
                              <Button v-if="orderDetail.isAlreadyCallOrder"
                                @click.native="showReply">{{$t('orders.businessReply')}}</Button>
                              <!-- 商家回复按钮 - end -->

                              <!-- 催单按钮 - start -->
                              <Button v-if="(orderDetail.sendType===1||orderDetail.sendType===4)
                                  && orderDetail.orderStatus!==1
                                  && orderDetail.orderStatus!==7
                                  && orderDetail.orderStatus!==100
                                  && orderDetail.orderStatus!==-1"
                                @click.native="callOrder(orderDetail)"
                                class="cd-btn"
                                :class="{'gray':!orderDetail.isCallOrder}">

                                <span>{{$t('orders.hurryUp')}}</span>
                                <span v-if="!orderDetail.isCallOrder && countdownMins > 0">{{countdownMins}} {{'minute'}}</span>
                                <span v-if="!orderDetail.isCallOrder && countdownSeconds > 0">{{countdownSeconds}} {{'second'}}</span>
                                <span v-if="!orderDetail.isCallOrder && countdownSeconds === 0 && orderDetail.isAlreadyCallOrder">0{{'second'}}</span>
                              </Button>
                              <!-- 催单按钮 - end -->
                            </div>
                          </div>
                          <ul class="list-tabs__ul">
                            <li style="width:130px;"><!-- 餐品 -->{{$t('orders.food')}}</li>
                            <li style="width:82px;"><!-- 份数 -->{{$t('orders.count[2]')}}</li>
                            <li style="width:100px;"><!-- 单价 -->{{$t('orders.prices[2]')}}</li>
                            <!-- 金额 -->
                            <!-- <li style="width:80px;">{{'金额'}}</li> -->
                          </ul>
                          <!-- 餐品列表 - start -->
                          <div
                            v-if="orderDetail.orderProducts && orderDetail.orderProducts.length > 0"
                            class="orders-tables"
                          >
                            <table v-for="(food, index) in orderDetail.orderProducts" :key="index" class="item__tb">
                              <tbody>
                                <tr class="item__tr">
                                  <template v-if="food.products && food.products.length > 0">
                                    <group-info :product="getGroup(food)">
                                      <td class="food-name" width="120" slot="title">
                                        {{ food.name }}
                                      </td>
                                      <td class="food-num" width="82">{{food.num}}</td>
                                      <td class="food-totalPrice" width="88">{{'￥' + food.realTimeTotalPrice}}</td>
                                    </group-info>
                                  </template>
                                  <template v-else>
                                    <td class="food-name" width="130" slot="title">
                                      {{ food.name }}
                                      <!-- 套餐详情 -->
                                      <!-- <Button
                                        v-if="food.products&&food.products.length>0"
                                        @click.native="showGroup(food)"
                                        class="cd-btn">{{'套餐详情'}}</Button> -->
                                    </td>
                                    <td class="food-num" width="82">{{food.num}}</td>
                                    <!-- <td class="food-price" width="100">{{'￥' + food.realTimePrice}}</td> -->
                                    <td class="food-totalPrice" width="88">{{'￥' + food.realTimeTotalPrice}}</td>
                                  </template>
                                </tr>
                              </tbody>
                            </table>
                            <!-- 餐饮费 -->
                            <!-- <table class="item__tb">
                              <tbody>
                                <tr class="item__tr">
                                  <td class="food-name" width="130">{{'餐饮费'}}</td>
                                  <td class="food-num" width="82">1</td>
                                  <td class="food-totalPrice" width="88">{{ '￥' + orderDetail.productPrice }}</td>
                                </tr>
                              </tbody>
                            </table> -->
                            <!-- 外送费 -->
                            <!-- <table class="item__tb" v-if="orderDetail.sendType != 2">
                              <tbody>
                                <tr class="item__tr">
                                  <td class="food-name" width="130">{{'外送费'}}</td>
                                  <td class="food-num" width="82">1</td>
                                  <td :class="{del: orderDetail.deliveryPrePrice!=0}" width="88">{{'￥'+orderDetail.deliveryFee}}</td>
                                  <td v-if="orderDetail.deliveryPrePrice!=0" width="88">
                                    {{'￥'+(orderDetail.deliveryFee + orderDetail.deliveryPrePrice).toFixed(accuracy)}}
                                  </td>
                                </tr>
                              </tbody>
                            </table> -->
                            <!-- 餐盒费 -->
                            <!-- <table class="item__tb" v-if="orderDetail.mealFee">
                              <tbody>
                                <tr class="item__tr">
                                  <td class="food-name" width="130">{{'餐盒费'}}</td>
                                  <td class="food-num" width="82">1</td>
                                  <td width="88">{{'￥'+orderDetail.mealFee}}</td>
                                </tr>
                              </tbody>
                            </table> -->
                            <!-- <p class="total-price__p">
                              <span>{{'总计'}}</span>
                              <span>{{'￥'+orderDetail.totalPrice}}</span>
                            </p> -->
                            <div class="feeInfo">
                              <p class="total-price__p">
                                <span>{{$t('orders.prices[2]')}}</span>
                                <span>{{ '￥' + orderDetail.productPrice }}</span>
                              </p>
                              <p class="total-price__p" v-if="orderDetail.sendType != 2 && orderDetail.deliveryFee!=0">
                                <span>{{$t('orders.fee[1]')}}</span>
                                <span>
                                  {{'￥'+(orderDetail.deliveryFee + orderDetail.deliveryPrePrice).toFixed(accuracy)}}
                                  <a v-if="orderDetail.deliveryPrePrice" :class="{del: orderDetail.deliveryPrePrice!=0}">{{'￥'+orderDetail.deliveryFee}}</a>
                                </span>
                              </p>
                              <p class="total-price__p" v-if="orderDetail.mealFee">
                                <span>{{$t('orders.fee[0]')}}</span>
                                <span>{{ '￥' + orderDetail.mealFee }}</span>
                              </p>
                              <!-- <p class="total-price__p" v-if="orderDetail.sendType != 2 && orderDetail.deliveryFee">
                                <span>{{$t('orders.fee[1]')}}</span>
                                <span>{{ '￥' + orderDetail.deliveryFee }}</span>
                              </p> -->
                            </div>
                            <p class="total-price__p">
                              <span><!-- 总额 -->{{$t('orders.total')}}</span>
                              <span>{{'￥'+orderDetail.totalPrice}}</span>
                            </p>
                          </div>
                          <!-- 餐品列表 - end -->

                          <!-- 套餐详情 - start -->
                          <!-- <div v-if="isShowGroup && index === currentIndex"
                            :style="{height: groupHeight}"
                            class="group-detail-box"
                            ref="group-detail">
                            <h3><a @click="isShowGroup=false" class="close" href="javascript:;">&times;</a></h3>

                            <div class="group-detail">
                              <h4>{{currentProduct.name}}</h4>

                              <div v-for="(item, ii) in currentProductGroupSet" :key="ii" class="group-item clearfix">
                                <div class="item-name">
                                  <span>{{item.name + (item.price>0?'￥'+item.price:'')}}</span>
                                  <span v-if="item.listPropertys.length > 0">
                                    <span v-for="(property, $index) in item.listPropertys" :key="$index">
                                      <span v-if="$index==0">(</span>
                                      <span>{{'第X份'.replace('X', $index+1)}}</span>
                                      <span>{{'第' + ($index+1) + 份: '}}</span>
                                      <span v-for="(prop, ii) in property.propertys" :key="ii">
                                        <em class="normal">
                                          {{prop.name + (prop.price>0?'￥'+prop.price:'') + (ii == property.propertys.length-1  ? '' : ',')}}
                                        </em>
                                      </span>
                                      <span v-if="$index==item.listPropertys.length-1">)</span>
                                      <span v-else>,</span>
                                    </span>

                                  </span>

                                </div>
                                <div class="item-num">{{'X份'.replace('X', item.num)}}</div>
                              </div>
                            </div>
                          </div> -->
                          <!-- 套餐详情 - end -->

                          <!-- 已享受优惠活动 -->
                          <!-- <div v-if="!orderDetail.orderPreferentials||(orderDetail.orderPreferentials&&!orderDetail.orderPreferentials.length)" class="pres-error"></div>
                          <div v-else class="order-pres-box">
                            <h4>{{'已享受优惠'}}</h4>
                            <p v-for="(pre,index) in orderDetail.orderPreferentials" :key="index"
                              v-if="pre.type !== 5">
                              {{pre.content&&pre.content!='null;'?pre.content:pre.title}}
                            </p>
                          </div> -->
                          <!-- 相应费用 -->
                          <!-- <div class="order-fees-box"> -->
                            <!-- <p>
                              <span>{{'餐饮费'}}</span>
                              <em>{{'￥'+orderDetail.productPrice}}</em>
                            </p>
                            <p v-if="orderDetail.sendType != 2">
                              <span>{{'外送费'}}</span>
                              <em :class="{del: orderDetail.deliveryPrePrice!=0}">{{'￥'+orderDetail.deliveryFee}}</em>
                              <em v-if="orderDetail.deliveryPrePrice!=0">{{'￥'+(orderDetail.deliveryFee + orderDetail.deliveryPrePrice).toFixed(accuracy)}}</em>
                            </p>
                            <p v-if="orderDetail.mealFee">
                              <span>{{'餐盒费'}}</span>
                              <em>{{'￥'+orderDetail.mealFee}}</em>
                            </p> -->
                            <!-- <p v-if="orderDetail.mealFee && projectName==='standard'"> -->
                              <!-- 餐盒费 -->
                             <!--  <span>{{'餐盒费'}}</span>
                              <em>{{'￥'+orderDetail.mealFee}}</em>
                              <span class="detail" @click.stop="showList = !showList;" :class="{'show': showList}" v-if="orderDetail.mealFee>0 && orderDetail.menuFeeList.length>0">{{'明细'}}</span>
                            </p> -->
                            <!-- <p v-if="showList">
                              <cd-list :width1="234" :width2="82" :width3="88" :data="orderDetail.menuFeeList" :type="'order'"></cd-list>
                            </p> -->
                            <!-- <p v-if="(projectName==='standard' || projectName==='jiaobanbisa') && orderDetail.peopleNum">
                              <span>{{'餐具数量'}}: </span>
                              <span v-if="orderDetail.peopleNum == 99">{{'不需要餐具'}}</span>
                              <span v-else-if="orderDetail.peopleNum == -10">{{'10 份以上'}}</span>
                              <span v-else-if="orderDetail.peopleNum == 1">{{'Y 份餐具'|replaceX('Y', orderDetail.peopleNum)}}</span>
                              <span v-else>{{'X 份餐具'|replaceX('X', orderDetail.peopleNum)}}</span>
                            </p> -->
                          <!-- </div> -->

                          <!-- 商家回复列表 - start -->
                          <div v-if="isShowReply && index === currentIndex"
                            :style="{height: replyHeight + 'px'}"
                            class="reply-list-box"
                            ref="reply-list">
                            <h3>
                              <span>{{$t('orders.businessReply')}}</span>
                              <a @click="closeReply" class="close" href="javascript:;">&times;</a>
                            </h3>
                            <div v-if="!orderDetail.replyList.length" class="reply-error">{{$t('orders.noBusinessReply')}}</div>
                            <div v-else class="reply-list" :style="{height: (replyHeight - 60) + 'px'}">
                              <div v-for="(reply, index) in orderDetail.replyList" :key="index" class="reply-item">
                                <span class="reply-msg">{{reply.replyText}}</span>
                                <span class="reply-time">{{reply.createTime}}</span>
                              </div>
                            </div>

                          </div>
                          <!-- 商家回复列表 - end -->

                          <!-- 取消进度 - start -->
                          <cancel-progress
                            v-if="isShowCancelProgress && index === currentIndex"
                            :order="orderDetail"
                            :offsetHeight="cancelHeight"
                            @close="closeReply"></cancel-progress>
                          <!-- 取消进度 - end -->

                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
             <!-- <cd-pagination class="pagination-box"
              :pageNow="pageNow"
              :pageSize="pageSize"
              :pages="pages"
              @change="changePage"></cd-pagination> -->
          </div>

          <div v-else class="no-order-tips"><!-- 暂无订单! -->{{$t('orders.noOrder')}}!</div>
          <!-- 订单列表 -->
       </div>
    </div>
    <!-- 骑手位置弹窗组件 -->
<!--     <rider-location v-if="modal.show && modal.template=='rider-location'"
      :orderDetail="modal.data"
      @close="cbShowLocation"></rider-location> -->
    <!-- 申请取消订单弹窗组件 -->
<!--     <cancel-order v-if="modal.show && modal.template=='cancel-order'"
      :orderDetail="modal.data"
      @close="cbShowLocation"></cancel-order> -->
    <!-- 订单评论弹窗组件 -->
<!--     <cd-comment v-if="modal.show && modal.template=='comment'"
      :orderDetail="modal.data"
      @save="cbSave"
      @close="close"></cd-comment> -->
  </div>
</template>
<script>
// import * as Com from 'project/common';
import { BASEKEY } from '@/config';
import { DEFAULT_WEBCONFIG } from '@/config/project-defult';
import { products } from '@/service/expands';
// import { getThridConfig } from "project/util/thridPartUtil";
// import riderLocation from './modal-rider-location';
// import cancelOrder from './modal-cancel-order';
import cancelProgress from '@/components/store/cancel-progress.vue';
import groupInfo from '@/components/dialog/groupInfo.vue';
// import cdList from '@/components/store/mealFeeList.vue';
// import cdComment from './modal-comment';

export default {
  name: 'orders',
  components: {
    // riderLocation,
    // cancelOrder,
    cancelProgress,
    [groupInfo.name]: groupInfo,
    // cdList,
    // cdComment
  },
  data() {
    return {
      compArr: DEFAULT_WEBCONFIG.json,
      locale: '',
      isLoading: false,
      isLoadingDetail: false,
      orders: [],
      orderDetail: {},
      currentIndex: -1,
      pageNow: 1,
      pageSize: 20,
      pages: 1,
      timer: null,
      isShowGroup: false,
      currentProductGroupSet: [],
      currentProduct: {},
      groupHeight: '0px',
      modal: {
        title: '',
        show: false,
        template: '',
        data: {},
      },
      countdown: null,
      countdownSecond: 0,
      countdownMins: 0, // 倒计时 - 分
      countdownSeconds: 0, // 倒计时 - 秒
      isShowReply: false, // 控制显示商家回复内容
      replyHeight: 420,
      accuracy: 2,
      isShowCancelProgress: false, // 控制显示取消订单申请进度
      cancelHeight: 420,
      showList: false,
      projectName: 'standard',
    };
  },
  computed: { // by Allen
    otherComponents() {
      return this.compArr.filter(
        x => x.type !== 'cd-page-header' && x.type !== 'cd-button',
      );
    },
    /**
     * isApplyCancelBtn 控制显示 “取消订单” 申请取消订单按钮
     * 条件: 商家已确认且非结束订单且未申请取消订单、用户申请取消订单且撤销申请
     */
    isApplyCancelBtn() {
      if (this.currentIndex > -1 && Object.keys(this.orderDetail).length > 0) {
        if (this.orderDetail.orderStatus !== 1 && this.orderDetail.orderStatus !== 7
          && this.orderDetail.orderStatus !== -1 && this.orderDetail.orderStatus !== 100
          && ((!this.orderDetail.isAlreadyCancelOrder
          || this.orderDetail.isAlreadyCancelOrder)
          && (this.orderDetail.orderRefund && this.orderDetail.orderRefund.status === 2))) {
          return true;
        }
      }
      return false;
    },
    /**
     * isCancelProgressBtn 控制显示 “取消进度” 查看取消申请进度按钮
     * 条件: 已申请取消订单、用户未撤销、商家拒绝
     */
    isCancelProgressBtn() {
      if (this.currentIndex > -1 && Object.keys(this.orderDetail).length > 0) {
        if (this.orderDetail.orderStatus !== 1 && this.orderDetail.orderStatus !== 7
          && this.orderDetail.orderStatus !== -1 && this.orderDetail.orderStatus !== 100
          && this.orderDetail.isAlreadyCancelOrder
          && this.orderDetail.orderRefund
          && this.orderDetail.orderRefund.status !== 2
          && this.orderDetail.orderRefund.status !== 3) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    currentIndex(val) {
      this.isShowGroup = false;
      this.isShowReply = false;
      this.isShowCancelProgress = false;
      // 清除倒计时
      if (this.countdown) {
        clearInterval(this.countdown);
        this.countdownMins = 0;
        this.countdownSeconds = 0;
      }
      if (val > -1) {
        this.getOrderDetail(this.orders[val].orderId);
      }
    },
  },
  async created() {
    // by Allen
    this.$service.project.getThridConfig(BASEKEY)
      .then((data) => {
        if (data) {
          this.compArr = data.pages.myAccount.json;
        }
      });
    // if (Com.projectName == 'zd') {
    //   this.compArr = defaultZdPageTypes[2].json;
    // } else if (Com.projectName == 'jiaobanbisa') {
    //   this.compArr = defaultJbbsPageTypes[2].json;
    // }
    this.$parent.currentModel = 'orders';
    this.locale = this.$i18n.locale;
    this.getOrders();
  },
  methods: {
    // 查看申请取消订单进度
    showCancelProgress() {
      // if (this.timer) clearInterval(this.timer);
      this.isShowCancelProgress = true;
      this.$nextTick(() => {
        const height = this.$refs['order-detail'][this.currentIndex].offsetHeight;
        this.cancelHeight = (height - 2);
      });
    },
    // 用户申请取消订单审核
    applyCancleorder() {
      if (this.orderDetail.isAlreadyCancelOrder) {
        let content = '';
        if (this.$i18n.locale === 'en') {
          content = `
            <p style="margin:10px auto 20px; width:300px;">You have recently applied online to cancel your order. To apply for cancellation, please contact the merchant by phone.</p>
            <p style="margin-top:8px;">
              <span>Business phone: </span>
              <span style="color:#ff5339;">${this.orderDetail.storePhone}</span>
            </p>
          `;
        } else {
          content = `
            <p style="margin:10px auto 20px; width:300px;">你最近已进行过一次线上申请取消订单，若要再次申请取消订单请电话联系商家</p>
            <p style="margin-top:8px;">
              <span>商家电话: </span>
              <span style="color:#ff5339;">${this.orderDetail.storePhone}</span>
            </p>
          `;
        }

        this.$Modal.info({ content });
      } else {
        if (this.timer) clearInterval(this.timer);
        this.modal.data = JSON.parse(JSON.stringify(this.orderDetail));
        this.modal.template = 'cancel-order';
        this.modal.show = true;
      }
    },

    // 催单商家回复
    showReply() {
      this.isShowReply = true;
      if (this.timer) clearInterval(this.timer);
      this.$nextTick(() => {
        const height = this.$refs['order-detail'][this.currentIndex].offsetHeight;
        this.replyHeight = (height - 2);
      });
    },

    /**
     * closeReply:void
     * 根据订单状态判断是否需要重新开启定时器
     * @param reload 是否需要重新加载订单详情547
     */
    closeReply(reload = false) {
      const self = this;
      self.isShowReply = false;
      self.isShowCancelProgress = false; // 兼容申请取消进度查询
      if (reload === true) {
        self.getOrderDetail(self.orderDetail.orderId);
      } else if (self.orderDetail.orderStatus !== 100 && self.orderDetail.orderStatus !== -1) {
        if (self.timer) clearInterval(self.timer);
        self.timer = setInterval(() => {
          self.getOrderDetail(self.orderDetail.orderId);
        }, 10000);
      }
    },
    // 催单
    callOrder(order) {
      if (!this.isLoadingDetail) {
        // this.isLoadingDetail = true;
        const self = this;
        // 预送达时间内
        if (!order.isCallOrder) {
          // 未催单
          if (!order.isAlreadyCallOrder) {
            this.$Modal.info({
              content: this.$t('tip.hurry[0]'),
              onOk() {
                self.isLoadingDetail = false;
              },
            });
          } else {
            // 已催单
            this.$Modal.info({
              content: '最近已进行过一次催单操作，暂不可再次催单',
              onOk() {
                self.isLoadingDetail = false;
              },
            });
          }
        } else if (order.isCallOrder) {
          // 预送达时间外
          if (order.orderStatus === 14) { // 订单状态为配送中
            let content = this.$i18n.locale === 'en' ? 'The food you ordered has been distributed by the rider. Do you need to contact the rider?' : '你订购的餐品已有骑手进行配送，是否需要联系该名骑手?';
            if (order.orderDrivers && order.orderDrivers.length > 0) {
              const { name } = order.orderDrivers[0];
              const { phone } = order.orderDrivers[0];
              content += this.$i18n.locale === 'en' ? `Rider name: ${name}Rider phone: ${phone}` : `骑手姓名: ${name}骑手电话: ${phone}`;
            } else {
              content += this.$i18n.locale === 'en' ? 'Rider information is not complete' : '骑手信息不全';
            }

            this.$Modal.info({
              content,
              onOk() {
                self.isLoadingDetail = false;
              },
            });
            return;
          } // 订单状态非配送中
          this.isLoadingDetail = true;
          this.$service.order.call({ content: { orderId: order.orderId, msg: '用户催单' } })
            .then(() => {
              this.$Modal.info({
                content: '催单请求已发送至商家，请耐心等待',
                onOk() {
                  self.getOrderDetail(order.orderId);
                },
              });
            });
        }
      }
    },
    // 套餐详情
    getGroup(good) {
      const goods = [];
      good.products.forEach((product) => {
        let listPropertys = [];
        if (product.listRequirements && product.listRequirements.length > 0) {
          listPropertys = products.groupSet.format_3(product.listRequirements);
        }
        goods.push(Object.assign(product, {
          listPropertys,
        }));
      });
      return good.products.concat([]);
      // this.currentProduct = { ...good };
      // this.isShowGroup = true;
      // this.$nextTick(() => {
      //   const height = this.$refs['order-detail'][this.currentIndex].offsetHeight;
      //   this.groupHeight = `${height - 2}px`;
      // });
    },
    // 关闭弹窗
    close() {
      this.modal.show = false;
      this.modal.template = '';
      this.modal.title = '';
      this.modal.data = {};
    },
    // 订单时间超过30天
    overTime(time) {
      if (Date.now() - new Date(time) > 60 * 60 * 24 * 30 * 1000) {
        return 0;
      }
      return 1;
    },
    // 打开评价弹框
    showComment() {
      this.modal.data = JSON.parse(JSON.stringify(this.orderDetail));
      this.modal.template = 'comment';
      this.modal.show = true;
    },
    // 成功添加评论，重新获取订单详情
    cbSave(order) {
      this.close();
      if (order && order.orderId) {
        this.getOrderDetail(order.orderId);
      }
    },
    // 关闭骑手弹窗callback
    cbShowLocation(order) {
      this.close();
      if (order && order.orderId) {
        this.getOrderDetail(order.orderId);
      }
    },
    // 查看骑手弹窗
    showRiderLocation() {
      if (this.timer) clearInterval(this.timer);
      this.modal.data = JSON.parse(JSON.stringify(this.orderDetail));
      this.modal.template = 'rider-location';
      this.modal.show = true;
    },
    // 完成订单 - 已取餐
    finishOrder(orderId) {
      if (!this.isLoadingDetail) {
        this.isLoadingDetail = true;
        this.$service.order.finish({ content: { orderId } })
          .then(() => {
            this.getOrderDetail(orderId);
          });
      }
    },
    // 用户取消订单
    cancelOrder(orderId) {
      if (!this.isLoading) {
        const self = this;
        this.$Modal.info({
          content: '取消订单？',
          onOk() {
            self.isLoading = true;
            self.$service.order.cancel({ content: { orderId } })
              .then(() => {
                self.isLoading = false;
                self.getOrderDetail(orderId);
              });
          },
        });
      }
    },
    // 继续支付
    gotoPay(order) {
      const { orderId } = order;
      // const href = `${window.location.origin}/booking.html/#/paying/${orderId}?key=${BASEKEY}`;
      const href = `${window.location.origin}/#/paying/${orderId}`;
      window.location.href = href;
    },
    // 切换当前订单
    changeItem(index) {
      this.currentIndex = index;
      this.showList = false;
    },
    changePage(num) {
      this.pageNow = num;
      this.$nextTick(() => {
        this.getOrders();
      });
    },
    // 获取订单详情
    getOrderDetail(orderId, callback = () => {}) {
      this.isLoadingDetail = true;
      const self = this;
      this.$service.order.getter({ content: { orderId } })
        .then((result) => {
          if (result.data) {
            this.$set(this, 'orderDetail', result.data);
            self.orders[self.currentIndex].status = result.data.progress[0].status;
            self.orders[self.currentIndex].statusName = result.data.progress[0].statusName;
            self.orders[self.currentIndex].statusType = result.data.progress[0].status;
            if (result.data.orderStatus !== 100 && result.data.orderStatus !== -1) {
              // 开启定时器
              if (self.timer) clearInterval(self.timer);
              self.timer = setInterval(() => {
                self.getOrderDetail(orderId, callback);
              }, 10000);
            } else {
              clearInterval(this.timer);
            }
            // !判断是否需要开启催单倒时计时器 -
            // todo 是否需要判断配送状态为配送中的时候关闭计时器 result.data.orderStatus !== 14
            if (result.data.countdownSecond > 0) {
              this.countdowned(result.data.countdownSecond);
            }
            this.isLoadingDetail = false;
            callback(result.data);
          }
        });
    },
    // 获取订单列表
    getOrders() {
      this.isLoading = true;
      this.currentIndex = -1;
      this.$service.order.list({ content: { pageNow: this.pageNow, pageSize: this.pageSize } })
        .then((result) => {
          this.isLoading = false;
          this.orders = [...result.data.rows];
          this.pages = result.data.pages;
          if (result.data.rows.length > 0) {
            this.currentIndex = 0;
          }
        });
    },
    // 催单倒计时
    countdowned(seconds) {
      if (!seconds) {
        this.countdown = null;
        return;
      }
      if (this.countdown) {
        clearInterval(this.countdown);
      }
      let mins = parseInt(seconds / 60, 10);
      let ss = seconds % 60;
      this.countdown = setInterval(() => {
        if (!ss) {
          if (mins) {
            mins -= 1;
            ss = 60;
          }
        }
        ss -= 1;
        this.countdownMins = mins;
        this.countdownSeconds = ss;
        if (!ss && !mins) {
          this.orderDetail.isCallOrder = true;
          clearInterval(this.countdown);
          this.countdown = null;
        }
      }, 1000);
    },

  },
  destroyed() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>
<style lang="sass" scoped>
@import '../../assets/css/mixins'
.del
  text-decoration: line-through
.user-orders-wrap
  .order-ls-title
    background-color: #ece6e6
    // height: 30px
    // line-height: 30px
    line-height: 30px
    text-align: center
    li
      color: #7a7a7a
      font-size: 14px
      display: inline-block
      vertical-align: middle
  .no-order-tips
    width: 150px
    height: 37px
    line-height: 37px
    margin: 175px auto 0 auto
    padding-left: 36px
    background: url('../../assets/image/icon/noOrders.png') no-repeat left center
  .order-list-wrap
    position: relative
    // padding-bottom: 100px
    .order-table-border
      border-bottom: 1px solid #cacaca
      .order__tb
        width: 100%
        color: #494949
        .order-intro, .order-detail
          border-bottom: 1px solid #f4f4f4
          position: relative
          min-height: 117px
        .order-intro
          height: 86px
          font-size: 14px
          text-align: center
          color: #7a7a7a
          .store-name
            width: 237px
            padding-left: 30px
            text-align: left
        .order-detail-box
          position: relative
          margin: 0 2px 14px
          min-height: 423px
          display: flex
          justify-content: center
          .order-detail__l
            float: left
            margin: 10px 0
            .order-detail-main
              position: relative
              width: 273px
              min-height: 72px
              min-height: 110px
              max-height: 110px
              color: #7a7a7a
              font-size: 12px
              padding: 6px 0
              border: 1px solid #dedede
              background-color: #fff
              overflow: auto
              > p
                span
                  width: 74px
                  display: inline-block
                  text-align: right
                padding: 3px 0 5px 5px
                line-height: 18px
                max-width: 253px
                word-wrap: break-word
                word-break: normal
              .order-type
                min-width: 25px
                height: 17px
                line-height: 17px
                text-align: center
                padding: 0px 5px
                color: #fff
                background-color: #f0604c
                font-weight: normal
                font-style: normal
                @include border-radius(4px)
            .order-cancel-reason
              font-size: 14px
              // color: #ff8b00
              color: #f0604c
              padding:
                top: 10px
                left: 20px
            .order-steps-box
              position: relative
              background-color: #fff
              margin-top: 5px
              border: 1px solid #e1e1e1
              width: 273px
              padding-left: 6px
              overflow-y: auto
              min-height: 281px
              max-height: 281px
              .status-msg
                position: relative
                min-height: 43px
                padding: 14px 10px 14px 17px
                margin: 8px 0px 15px 28px
                background-color: #e5f0ea
                z-index: 2
                width: 85%
                > span
                  display: inline-block
                  line-height: 20px
                .step-name
                  font-size: 14px
                  color: #494949
                  font-weight: bold
                  float: left
                .step-time
                  color: #7a7a7a
                  float: right
                &:before, &:after
                  display: inline-block
                &:first-child:before
                  content: url('../../assets/image/icon/icon-point1.png')
                &:before
                  position: absolute
                  left: -28px
                  content: url('../../assets/image/icon/icon-point2.png')
                &:after
                  border-color: transparent #e5f0ea transparent transparent
                  border-style: solid
                  content: ''
                  position: absolute
                  border-width: 8px
                  left: -14px
                  top: 15px
                .progress-btn-box
                  text-align: right
                  clear: both
                  margin-top: 24px

              .order-step-bar
                position: absolute
                top: 30px
                left: 12px
                z-index: 1
                width: 7px
                background: #acd598
                &.step-2
                  height: 68px
                &.step-3
                  height: 128px
                  &.step-4-1
                    height: 170px
                &.step-4
                  height: 186px
                  &.step-4-1
                    height: 228px
                &.step-5
                  height: 256px
                &.step-6
                  height: 326px
          .order-detail__r
            position: relative
            float: right
            width: 420px
            border: 1px solid #dedede
            background-color: #fff
            overflow-x: hidden
            max-height: 396px
            min-height: 396px
            overflow-y: auto
            margin: 10px 0 0 5px
            padding: 0 5px 0 12px
            .order-title-box
              min-height: 46px
              position: relative
              h4
                font-size: 18px
                color: #0f9675
                position: absolute
                line-height: 46px
                font-weight: initial
              .order-control-btns
                float: right
                margin:
                  top: 2px
                  right: 5px
                .cd-button.gray,
                .cd-button.is-disabled
                  background-color: #999!important
            .list-tabs__ul
              height: 25px
              line-height: 25px
              border-bottom: 1px solid #e0e0e0
              margin-bottom: 5px
              padding-bottom: 5px
              li
                &:first-child
                  text-align: left
                float: left
                font-size: 14px
                color: #7a7a7a
                line-height: 21px
                vertical-align: top
                text-align: center
            .orders-tables
              width: 100%
              height: 313px
              overflow-y: auto
              color: #7a7a7a
              .feeInfo
                border-top: 1px solid #e0e0e0
                border-bottom: 1px solid #e0e0e0
                padding: 8px 90px 8px 15px
                margin-bottom: 10px
              .total-price__p
                bottom: 5px
                right: 0px
                font-size: 14px
                text-align: right
                padding-bottom: 3px
                vertical-align: top
                span
                  display: inline-block
                  a
                    color: #7A7A7A
                    cursor: default
                  &:last-child
                    width: 120px
                    text-align: right
                    padding-right: 35px
              .item__tb
                height: auto
                color: #5b5b5b
                text-align: center
                margin-bottom: 5px
                .item__tr
                  height: 24px
                  font-size: 14px
                  color: #7a7a7a
                  .food-name
                    text-align: left
                    word-break: break-word
                  .food-btn
                    min-width: 86px
                    line-height: 18px
            .group-detail-box,
            .reply-list-box
              position: absolute
              top: 0px
              left: 0px
              width: 420px
              overflow-y: auto
              padding-right: 10px
              background-color: #fff
              z-index: 10
              h3
                text-align: right
                .close
                  display: inline-block
                  width: 21px
                  height: 21px
                  font-size: 21px
                  font-weight: 700
                  line-height: 1
                  color: #fc8b00
                  text-shadow: 0 1px 0 #fff
                  text-align: right
                  margin: 8px 0 18px 0
                  font-style: normal
                  cursor: pointer
            .group-detail
              padding: 0 18px
              h4
                color: #494949
                font-size: 14px
                line-height: 28px
                margin-top: 18px
                &:first-child
                  margin-top: 0px
              .group-item
                line-height: 28px
                color: #5b5b5b
                .item-name
                  float: left
                  display: block
                  max-width: 400px
                .item-num
                  float: right
                .normal
                  font-style: normal
            .pres-error
              min-height: 85px
            .order-pres-box
              padding-top: 5px
              margin: 5px 30px 0px 15px
              border-top: 1px solid #e0e0e0
              h4
                height: 20px
                line-height: 20px
              p
                min-height: 18px
                line-height: 18px
                max-height: 54px
                overflow-y: auto
                color: #f0604c
            .order-fees-box
              position: relative
              margin: 10px 30px 0px 15px
              padding-bottom: 24px
              font-weight: bold
              p
                font-size: 14px
                span, em
                  display: inline-block
                  vertical-align: top
                em
                  color: #f9851d
                  font-style: normal
                  &.del
                    color: #494949
                    text-decoration: line-through
              .detail
                margin-left: 12px
                color: #c5c5c5
                background: url('../../assets/image/icon/arrow-top.png') right no-repeat
                padding-right: 14px
                cursor: pointer
                &.show
                  background: url('../../assets/image/icon/arrow-down.png') right no-repeat
            .reply-list-box
              h3
                text-align: left
                border-bottom: 1px solid #e0e0e0
                font-size: 16px
                margin-left: 10px
                padding-left: 10px
                position: relative
                line-height: 48px
                span
                  display: inline-block
                a
                  position: absolute
                  top: 5px
                  right: 5px
              .reply-error
                line-height: 48px
                text-align: center
              .reply-list
                overflow-y: auto
              .reply-item
                display: table
                min-height: 48px
                border-bottom: 1px solid #f1f1f1
                margin:
                  left: 8px
                  right: 20px
                span
                  display: table-cell
                  vertical-align: middle
                .reply-msg
                  width: 305px
                  padding: 15px
                .reply-time
                  width: 140px
                  text-align: center
    .pagination-box
      position: absolute
      bottom: 40px
      right: 0px
</style>
<style>
.user-orders-wrap .meal-fee-wrap {
  font-weight: normal;
}
.user-orders-wrap .meal-fee-wrap .item .box .name {
  width: 230px;
  color: #7a7a7a;
}
</style>
